import { render } from "./Kegiatan.vue?vue&type=template&id=d50aefca"
import script from "./Kegiatan.vue?vue&type=script&lang=js"
export * from "./Kegiatan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__